import { Order, OrderBag, Bin, OrderProduct, REPAIR_STATUS } from "@/types";

export interface ScannerData {
  data: string;
}

export interface Scanner {
  friendlyName: string;
  disable?: () => void | Promise<void>;
  start?: () => void | Promise<void>;
  stop?: () => void | Promise<void>;
  enable?: (options: { autoRead: boolean }, callback: (data: ScannerData) => void) => void | Promise<void>;
}

export interface ScanActionApiResponse {
  code: OrderCheckCode;
  isValid: boolean;
  message?: string;
  data?: {
    currentBinId?: string | null;
    currentBagId?: string | null;
    orderStatus?: REPAIR_STATUS;
  };
  bin?: {
    name: string;
  };
  bag?: {
    sequence: number;
  };
  orderProduct?: {
    sequence: string;
    name: string;
  };
  order?: Order;
}

export interface ApiResponse {
  message?: string
  order?: Order;
  bin?: Bin;
  orderBag?: OrderBag;
  orderProduct?: OrderProduct;
  code?: OrderCheckCode;
  error?: string;
}

export interface ScanActionApiResponseNew extends ApiResponse {
  isValid: boolean;
  qualityCheckProgress?: number; // 0 to 1 (1 is quality check is completed)
  action: QualityCheckAction; // echo from POST value
}

export interface CounterPickupApiResponse extends ApiResponse {
  counterPickupAt?: string;
  response?: {
    message?: string;
  }
}

export interface ReadyToSendApiResponse extends Partial<OrderBag> {
  message?: string;
  error?: string;
}

export type OrderCheckCode =
  | "BIN_DATASTRING"
  | "BAG_DATASTRING"
  | "BINS_MATCH"
  | "BAG_AND_PRODUCT_MATCH"
  | "PRODUCT_AND_BAG_MATCH"
  | 'BIN_AND_BAG_MATCH'
  | "ORDER_PRODUCT_WITHOUT_BIN"
  | "BINS_DO_NOT_MATCH"
  | "BAGS_DO_NOT_MATCH"
  | "ORDER_BAG_NOT_FOUND"
  | "ORDER_BIN_NOT_FOUND"
  | "ORDER_PRODUCT_NOT_FOUND"
  | "ORDER_STATUS_TRANSITION_FAILED" // when the current Order status does not allow a the change to the new status (for example from "CLOSED" to "BOOKING")
  | "BIN_NOT_FOUND"
  | "ORDER_PRECONDITION_FAILED" // The Order does not match the preconditions for the the scan action
  | "BAG_NOT_FOUND"
  | "ORDER_NOT_FOUND"
  | "INVALID_BARCODE_DATA"
  | "INVALID_ORDER_DELIVERY_METHOD"
  | "INVALID_ORDER_PAYMENT_STATUS"
  | "INVALID_ORDER_BAG_STATUS";

interface ScanCheck {
  code: OrderCheckCode;
  responseData: ScanActionApiResponse;
}

export interface BinScanCheck extends ScanCheck {
  currentBinName: string;
  currentBinId: string | null;
}

export interface BagScanCheck extends ScanCheck {
  currentBagSequence: number | undefined;
  currentBagId: string | null;
}

// ---------------------- v2
export enum QualityCheckAction {
  BAG_PRODUCTS = "bag_products",
  BIN_BAGS = "bin_bags",
}

export interface DataStringDto {
  dataString: string;
}

export interface DataLabelDto extends DataStringDto {
  type: BarcodeDataType;
}

export interface QualityCheckDto {
  action: QualityCheckAction;
  dataStrings: DataLabelDto[];
}

export interface ReadyToSendDto extends DataStringDto {
  binId: number,
  orderId: string,
}

// NOTE: ONLY ADD VALUES, do not sort or remove.
// Should match BarcodeDataType used on the backend-end.
export enum BarcodeDataType {
  ORDER = 1,
  ORDER_PRODUCT,
  CUSTOMER,
  ORDER_BIN,
  ORDER_BAG,
}
